var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 12.5926,
    rx: 13,
    ry: 12.5926,
    fill: "#F1F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5071 19.0502H16.4938C18.3338 19.0502 19.4138 18.0419 19.5004 16.7116V10.9716C19.5938 9.57673 18.4471 9.04074 17.0004 9.04074C16.5938 9.04074 16.2204 8.81472 16.0338 8.466L15.5538 7.52963C15.2471 6.94197 14.4471 6.45764 13.7671 6.45764H12.2404C11.5538 6.45764 10.7538 6.94197 10.4471 7.52963L9.9671 8.466C9.78044 8.81472 9.4071 9.04074 9.00044 9.04074C7.55377 9.04074 6.4071 9.57673 6.50044 10.9716L6.50034 16.7116C6.58034 18.0419 7.6671 19.0502 9.5071 19.0502Z",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.0095H14",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 16.4672C14.193 16.4672 15.1663 15.5244 15.1663 14.3684C15.1663 13.2125 14.193 12.2697 12.9997 12.2697C11.8063 12.2697 10.833 13.2125 10.833 14.3684C10.833 15.5244 11.8063 16.4672 12.9997 16.4672Z",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/editProfile.418958a69bced54ce5bf3f0771ae411e.svg";
export { ForwardRef as ReactComponent };